/**
 * Aritmética del escalonado de la cuadrícula.
 *
 * Vive aquí, junto al canvas que la usa, y **es la única definición de la
 * convención**: la comparten el dibujo y la detección de toques. Si cada uno
 * tuviera la suya, bastaría con que una cambiara para que el dedo pintara media
 * mostacilla corrida respecto de lo que se ve.
 *
 * No sabe qué es un patrón peyote: recibe un `boolean`. Saber que el peyote se
 * dibuja escalonado es cosa de quien tiene el dominio delante.
 */

/**
 * Desfase horizontal de una fila, en fracción de mostacilla.
 *
 * `row` es el índice base 0: la fila que la usuaria ve como «1» se alinea con
 * el borde y la que ve como «2» se corre media mostacilla a la derecha. De ahí
 * salen dos cosas: que la mostacilla del extremo derecho de cada fila corrida
 * quede sin par completo arriba, y que un diseño de una sola fila se dibuje sin
 * desfase.
 */
export function staggerOffsetCells(row: number, staggered: boolean): number {
  return staggered && row % 2 === 1 ? 0.5 : 0;
}

/**
 * Ancho que ocupa la cuadrícula, en mostacillas, con el saliente incluido.
 *
 * Las filas corridas sobresalen media mostacilla a la derecha. Olvidarlo hace
 * que «ver todo» recorte la última columna de esas filas.
 */
export function gridWidthInCells(columns: number, staggered: boolean): number {
  return columns + (staggered ? 0.5 : 0);
}
